import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemplateMenu = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M5.308 21.5c-.499 0-.925-.177-1.278-.53a1.742 1.742 0 0 1-.53-1.278V6.308c0-.499.177-.925.53-1.278.353-.353.779-.53 1.278-.53h4.271a.213.213 0 0 0 .205-.177c.09-.479.324-.892.7-1.24.422-.388.928-.583 1.516-.583a2.17 2.17 0 0 1 1.525.584c.376.346.606.759.692 1.237a.213.213 0 0 0 .206.18h4.27c.498-.001.924.176 1.277.529.353.353.53.779.53 1.278v13.384c0 .499-.177.925-.53 1.278-.353.353-.779.53-1.278.53H5.308Zm0-1.5h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V6.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096ZM12 5.346a.729.729 0 0 0 .75-.75.729.729 0 0 0-.75-.75.728.728 0 0 0-.75.75.728.728 0 0 0 .75.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M11.772 10.176H9V9h6.876v1.176h-2.772v7.392h-1.332v-7.392Z"
		})
	]
});
const ForwardRef = forwardRef(SvgTemplateMenu);
export { ForwardRef as ReactComponent };
